/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const LoadingIcon = ({ variant = "warning" }) => {
  let stroke;

  return (
    <svg
      width="30"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.5"
        cx="16.7589"
        cy="16.7726"
        r="15.3775"
        stroke={"currentColor"}
        strokeWidth="1.88"
      />
      <circle
        cx="16.7589"
        cy="16.7726"
        r="15.3775"
        stroke={"currentColor"}
        strokeWidth="1.88"
        strokeDasharray="12"
        strokeDashoffset="54"
      />
    </svg>
  );
};

export default LoadingIcon;
